import { render, staticRenderFns } from "./ProjectSettingsEmbedded.vue?vue&type=template&id=dd5bcdd0&scoped=true"
import script from "./ProjectSettingsEmbedded.vue?vue&type=script&lang=js"
export * from "./ProjectSettingsEmbedded.vue?vue&type=script&lang=js"
import style0 from "./ProjectSettingsEmbedded.vue?vue&type=style&index=0&id=dd5bcdd0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd5bcdd0",
  null
  
)

export default component.exports